<template>
    <div class="gz-page-loader">
        <div class="gz-loader gz-loader_page spin-cw"></div>
    </div>
</template>

<script>
export default {
    name: 'BasePageLoader'
}
</script>